"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: txactivity/activity-details-section.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftxactivity%2Factivity-details-section.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineSectionTimelineEvent = exports.TimelineSection = exports.FeeBreakdownSectionFeeBreakdownRow = exports.FeeBreakdownSection = exports.BnplRepaymentSection = exports.RetrySavingsMatchingSection = exports.MerchantActivitySection = exports.CardReplacementSection = exports.RelatedGiftCardSection = exports.CheckImageSection = exports.CashAdvanceCompletedBnplPlansSection = exports.ParagraphsSection = exports.SupportSectionCancelDispute = exports.SupportSectionDisputableActivity = exports.SupportSection = exports.ActionablePurchase = exports.ActionsSection = exports.ContactInfoSection = exports.LocationSection = exports.RelatedActivitySection = exports.TableItem = exports.TableItemSection = exports.DateSection = exports.NoteSection = exports.DescriptionSectionReferralTerms = exports.DescriptionSectionSavingsInterest = exports.DescriptionSectionBlackUpsellLink = exports.DescriptionSection = exports.ActivityDetailsSectionBody = exports.ActivityDetailsSection = void 0;
const amount_1 = require("../common/amount");
const geo_location_1 = require("../common/geo-location");
const merchant_1 = require("../common/merchant");
const activity_action_1 = require("./activity-action");
const activity_common_1 = require("./activity-common");
const icon_1 = require("./icon");
const string_1 = require("./string");
const protobufPackage = 'com.step.txactivity.proto';
function createBaseActivityDetailsSection() {
    return { title: undefined, body: exports.ActivityDetailsSectionBody.fromPartial({}) };
}
exports.ActivityDetailsSection = {
    fromJSON(object) {
        const message = {
            body: isSet(object.body)
                ? exports.ActivityDetailsSectionBody.fromJSON(object.body)
                : exports.ActivityDetailsSectionBody.fromPartial({}),
        };
        if (isSet(object.title)) {
            message.title = string_1.StyledString.fromJSON(object.title);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.title !== undefined) {
            obj.title = string_1.StyledString.toJSON(message.title);
        }
        if (message.body !== undefined) {
            obj.body = exports.ActivityDetailsSectionBody.toJSON(message.body);
        }
        return obj;
    },
    create(base) {
        return exports.ActivityDetailsSection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActivityDetailsSection();
        message.title = (object.title !== undefined && object.title !== null)
            ? string_1.StyledString.fromPartial(object.title)
            : undefined;
        message.body = (object.body !== undefined && object.body !== null)
            ? exports.ActivityDetailsSectionBody.fromPartial(object.body)
            : exports.ActivityDetailsSectionBody.fromPartial({});
        return message;
    },
};
function createBaseActivityDetailsSectionBody() {
    return {
        description: undefined,
        note: undefined,
        date: undefined,
        tableItem: undefined,
        relatedActivity: undefined,
        location: undefined,
        contactInfo: undefined,
        actions: undefined,
        support: undefined,
        paragraphs: undefined,
        feeBreakdown: undefined,
        timeline: undefined,
        cashAdvanceCompletedBnplPlans: undefined,
        checkImage: undefined,
        relatedGiftCard: undefined,
        cardReplacement: undefined,
        merchantActivity: undefined,
        retrySavingsMatching: undefined,
        bnplRepayment: undefined,
    };
}
exports.ActivityDetailsSectionBody = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.description)) {
            message.description = exports.DescriptionSection.fromJSON(object.description);
        }
        if (isSet(object.note)) {
            message.note = exports.NoteSection.fromJSON(object.note);
        }
        if (isSet(object.date)) {
            message.date = exports.DateSection.fromJSON(object.date);
        }
        if (isSet(object.tableItem)) {
            message.tableItem = exports.TableItemSection.fromJSON(object.tableItem);
        }
        if (isSet(object.relatedActivity)) {
            message.relatedActivity = exports.RelatedActivitySection.fromJSON(object.relatedActivity);
        }
        if (isSet(object.location)) {
            message.location = exports.LocationSection.fromJSON(object.location);
        }
        if (isSet(object.contactInfo)) {
            message.contactInfo = exports.ContactInfoSection.fromJSON(object.contactInfo);
        }
        if (isSet(object.actions)) {
            message.actions = exports.ActionsSection.fromJSON(object.actions);
        }
        if (isSet(object.support)) {
            message.support = exports.SupportSection.fromJSON(object.support);
        }
        if (isSet(object.paragraphs)) {
            message.paragraphs = exports.ParagraphsSection.fromJSON(object.paragraphs);
        }
        if (isSet(object.feeBreakdown)) {
            message.feeBreakdown = exports.FeeBreakdownSection.fromJSON(object.feeBreakdown);
        }
        if (isSet(object.timeline)) {
            message.timeline = exports.TimelineSection.fromJSON(object.timeline);
        }
        if (isSet(object.cashAdvanceCompletedBnplPlans)) {
            message.cashAdvanceCompletedBnplPlans = exports.CashAdvanceCompletedBnplPlansSection.fromJSON(object.cashAdvanceCompletedBnplPlans);
        }
        if (isSet(object.checkImage)) {
            message.checkImage = exports.CheckImageSection.fromJSON(object.checkImage);
        }
        if (isSet(object.relatedGiftCard)) {
            message.relatedGiftCard = exports.RelatedGiftCardSection.fromJSON(object.relatedGiftCard);
        }
        if (isSet(object.cardReplacement)) {
            message.cardReplacement = exports.CardReplacementSection.fromJSON(object.cardReplacement);
        }
        if (isSet(object.merchantActivity)) {
            message.merchantActivity = exports.MerchantActivitySection.fromJSON(object.merchantActivity);
        }
        if (isSet(object.retrySavingsMatching)) {
            message.retrySavingsMatching = exports.RetrySavingsMatchingSection.fromJSON(object.retrySavingsMatching);
        }
        if (isSet(object.bnplRepayment)) {
            message.bnplRepayment = exports.BnplRepaymentSection.fromJSON(object.bnplRepayment);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.description !== undefined) {
            obj.description = exports.DescriptionSection.toJSON(message.description);
        }
        if (message.note !== undefined) {
            obj.note = exports.NoteSection.toJSON(message.note);
        }
        if (message.date !== undefined) {
            obj.date = exports.DateSection.toJSON(message.date);
        }
        if (message.tableItem !== undefined) {
            obj.tableItem = exports.TableItemSection.toJSON(message.tableItem);
        }
        if (message.relatedActivity !== undefined) {
            obj.relatedActivity = exports.RelatedActivitySection.toJSON(message.relatedActivity);
        }
        if (message.location !== undefined) {
            obj.location = exports.LocationSection.toJSON(message.location);
        }
        if (message.contactInfo !== undefined) {
            obj.contactInfo = exports.ContactInfoSection.toJSON(message.contactInfo);
        }
        if (message.actions !== undefined) {
            obj.actions = exports.ActionsSection.toJSON(message.actions);
        }
        if (message.support !== undefined) {
            obj.support = exports.SupportSection.toJSON(message.support);
        }
        if (message.paragraphs !== undefined) {
            obj.paragraphs = exports.ParagraphsSection.toJSON(message.paragraphs);
        }
        if (message.feeBreakdown !== undefined) {
            obj.feeBreakdown = exports.FeeBreakdownSection.toJSON(message.feeBreakdown);
        }
        if (message.timeline !== undefined) {
            obj.timeline = exports.TimelineSection.toJSON(message.timeline);
        }
        if (message.cashAdvanceCompletedBnplPlans !== undefined) {
            obj.cashAdvanceCompletedBnplPlans = exports.CashAdvanceCompletedBnplPlansSection.toJSON(message.cashAdvanceCompletedBnplPlans);
        }
        if (message.checkImage !== undefined) {
            obj.checkImage = exports.CheckImageSection.toJSON(message.checkImage);
        }
        if (message.relatedGiftCard !== undefined) {
            obj.relatedGiftCard = exports.RelatedGiftCardSection.toJSON(message.relatedGiftCard);
        }
        if (message.cardReplacement !== undefined) {
            obj.cardReplacement = exports.CardReplacementSection.toJSON(message.cardReplacement);
        }
        if (message.merchantActivity !== undefined) {
            obj.merchantActivity = exports.MerchantActivitySection.toJSON(message.merchantActivity);
        }
        if (message.retrySavingsMatching !== undefined) {
            obj.retrySavingsMatching = exports.RetrySavingsMatchingSection.toJSON(message.retrySavingsMatching);
        }
        if (message.bnplRepayment !== undefined) {
            obj.bnplRepayment = exports.BnplRepaymentSection.toJSON(message.bnplRepayment);
        }
        return obj;
    },
    create(base) {
        return exports.ActivityDetailsSectionBody.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActivityDetailsSectionBody();
        message.description = (object.description !== undefined && object.description !== null)
            ? exports.DescriptionSection.fromPartial(object.description)
            : undefined;
        message.note = (object.note !== undefined && object.note !== null)
            ? exports.NoteSection.fromPartial(object.note)
            : undefined;
        message.date = (object.date !== undefined && object.date !== null)
            ? exports.DateSection.fromPartial(object.date)
            : undefined;
        message.tableItem = (object.tableItem !== undefined && object.tableItem !== null)
            ? exports.TableItemSection.fromPartial(object.tableItem)
            : undefined;
        message.relatedActivity =
            (object.relatedActivity !== undefined && object.relatedActivity !== null)
                ? exports.RelatedActivitySection.fromPartial(object.relatedActivity)
                : undefined;
        message.location = (object.location !== undefined && object.location !== null)
            ? exports.LocationSection.fromPartial(object.location)
            : undefined;
        message.contactInfo = (object.contactInfo !== undefined && object.contactInfo !== null)
            ? exports.ContactInfoSection.fromPartial(object.contactInfo)
            : undefined;
        message.actions = (object.actions !== undefined && object.actions !== null)
            ? exports.ActionsSection.fromPartial(object.actions)
            : undefined;
        message.support = (object.support !== undefined && object.support !== null)
            ? exports.SupportSection.fromPartial(object.support)
            : undefined;
        message.paragraphs = (object.paragraphs !== undefined && object.paragraphs !== null)
            ? exports.ParagraphsSection.fromPartial(object.paragraphs)
            : undefined;
        message.feeBreakdown = (object.feeBreakdown !== undefined && object.feeBreakdown !== null)
            ? exports.FeeBreakdownSection.fromPartial(object.feeBreakdown)
            : undefined;
        message.timeline = (object.timeline !== undefined && object.timeline !== null)
            ? exports.TimelineSection.fromPartial(object.timeline)
            : undefined;
        message.cashAdvanceCompletedBnplPlans =
            (object.cashAdvanceCompletedBnplPlans !== undefined &&
                object.cashAdvanceCompletedBnplPlans !== null)
                ? exports.CashAdvanceCompletedBnplPlansSection.fromPartial(object.cashAdvanceCompletedBnplPlans)
                : undefined;
        message.checkImage = (object.checkImage !== undefined && object.checkImage !== null)
            ? exports.CheckImageSection.fromPartial(object.checkImage)
            : undefined;
        message.relatedGiftCard =
            (object.relatedGiftCard !== undefined && object.relatedGiftCard !== null)
                ? exports.RelatedGiftCardSection.fromPartial(object.relatedGiftCard)
                : undefined;
        message.cardReplacement =
            (object.cardReplacement !== undefined && object.cardReplacement !== null)
                ? exports.CardReplacementSection.fromPartial(object.cardReplacement)
                : undefined;
        message.merchantActivity =
            (object.merchantActivity !== undefined && object.merchantActivity !== null)
                ? exports.MerchantActivitySection.fromPartial(object.merchantActivity)
                : undefined;
        message.retrySavingsMatching =
            (object.retrySavingsMatching !== undefined && object.retrySavingsMatching !== null)
                ? exports.RetrySavingsMatchingSection.fromPartial(object.retrySavingsMatching)
                : undefined;
        message.bnplRepayment = (object.bnplRepayment !== undefined && object.bnplRepayment !== null)
            ? exports.BnplRepaymentSection.fromPartial(object.bnplRepayment)
            : undefined;
        return message;
    },
};
function createBaseDescriptionSection() {
    return {
        description: undefined,
        blackUpsell: undefined,
        savingsInterest: undefined,
        referralTerms: undefined,
    };
}
exports.DescriptionSection = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.description)) {
            message.description = string_1.StyledString.fromJSON(object.description);
        }
        if (isSet(object.blackUpsell)) {
            message.blackUpsell = exports.DescriptionSectionBlackUpsellLink.fromJSON(object.blackUpsell);
        }
        if (isSet(object.savingsInterest)) {
            message.savingsInterest = exports.DescriptionSectionSavingsInterest.fromJSON(object.savingsInterest);
        }
        if (isSet(object.referralTerms)) {
            message.referralTerms = exports.DescriptionSectionReferralTerms.fromJSON(object.referralTerms);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.description !== undefined) {
            obj.description = string_1.StyledString.toJSON(message.description);
        }
        if (message.blackUpsell !== undefined) {
            obj.blackUpsell = exports.DescriptionSectionBlackUpsellLink.toJSON(message.blackUpsell);
        }
        if (message.savingsInterest !== undefined) {
            obj.savingsInterest = exports.DescriptionSectionSavingsInterest.toJSON(message.savingsInterest);
        }
        if (message.referralTerms !== undefined) {
            obj.referralTerms = exports.DescriptionSectionReferralTerms.toJSON(message.referralTerms);
        }
        return obj;
    },
    create(base) {
        return exports.DescriptionSection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDescriptionSection();
        message.description = (object.description !== undefined && object.description !== null)
            ? string_1.StyledString.fromPartial(object.description)
            : undefined;
        message.blackUpsell = (object.blackUpsell !== undefined && object.blackUpsell !== null)
            ? exports.DescriptionSectionBlackUpsellLink.fromPartial(object.blackUpsell)
            : undefined;
        message.savingsInterest =
            (object.savingsInterest !== undefined && object.savingsInterest !== null)
                ? exports.DescriptionSectionSavingsInterest.fromPartial(object.savingsInterest)
                : undefined;
        message.referralTerms = (object.referralTerms !== undefined && object.referralTerms !== null)
            ? exports.DescriptionSectionReferralTerms.fromPartial(object.referralTerms)
            : undefined;
        return message;
    },
};
function createBaseDescriptionSectionBlackUpsellLink() {
    return {};
}
exports.DescriptionSectionBlackUpsellLink = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.DescriptionSectionBlackUpsellLink.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseDescriptionSectionBlackUpsellLink();
        return message;
    },
};
function createBaseDescriptionSectionSavingsInterest() {
    return { interestDetails: '' };
}
exports.DescriptionSectionSavingsInterest = {
    fromJSON(object) {
        const message = {
            interestDetails: isSet(object.interestDetails)
                ? globalThis.String(object.interestDetails)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.interestDetails !== '') {
            obj.interestDetails = message.interestDetails;
        }
        return obj;
    },
    create(base) {
        return exports.DescriptionSectionSavingsInterest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDescriptionSectionSavingsInterest();
        message.interestDetails = object.interestDetails ?? '';
        return message;
    },
};
function createBaseDescriptionSectionReferralTerms() {
    return {};
}
exports.DescriptionSectionReferralTerms = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.DescriptionSectionReferralTerms.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseDescriptionSectionReferralTerms();
        return message;
    },
};
function createBaseNoteSection() {
    return { note: string_1.StyledString.fromPartial({}) };
}
exports.NoteSection = {
    fromJSON(object) {
        const message = {
            note: isSet(object.note) ? string_1.StyledString.fromJSON(object.note) : string_1.StyledString.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.note !== undefined) {
            obj.note = string_1.StyledString.toJSON(message.note);
        }
        return obj;
    },
    create(base) {
        return exports.NoteSection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseNoteSection();
        message.note = (object.note !== undefined && object.note !== null)
            ? string_1.StyledString.fromPartial(object.note)
            : string_1.StyledString.fromPartial({});
        return message;
    },
};
function createBaseDateSection() {
    return { dateMs: '0', isScheduled: false };
}
exports.DateSection = {
    fromJSON(object) {
        const message = {
            dateMs: isSet(object.dateMs) ? globalThis.String(object.dateMs) : '0',
            isScheduled: isSet(object.isScheduled) ? globalThis.Boolean(object.isScheduled) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.dateMs !== '0') {
            obj.dateMs = message.dateMs;
        }
        if (message.isScheduled !== false) {
            obj.isScheduled = message.isScheduled;
        }
        return obj;
    },
    create(base) {
        return exports.DateSection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDateSection();
        message.dateMs = object.dateMs ?? '0';
        message.isScheduled = object.isScheduled ?? false;
        return message;
    },
};
function createBaseTableItemSection() {
    return { items: [] };
}
exports.TableItemSection = {
    fromJSON(object) {
        const message = {
            items: globalThis.Array.isArray(object?.items)
                ? object.items.map((e) => exports.TableItem.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.items?.length) {
            obj.items = message.items.map((e) => exports.TableItem.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.TableItemSection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTableItemSection();
        message.items = object.items?.map((e) => exports.TableItem.fromPartial(e)) || [];
        return message;
    },
};
function createBaseTableItem() {
    return { icon: undefined, title: undefined, subtitle: undefined, amount: undefined };
}
exports.TableItem = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.icon)) {
            message.icon = icon_1.IconDescriptor.fromJSON(object.icon);
        }
        if (isSet(object.title)) {
            message.title = string_1.StyledString.fromJSON(object.title);
        }
        if (isSet(object.subtitle)) {
            message.subtitle = string_1.StyledString.fromJSON(object.subtitle);
        }
        if (isSet(object.amount)) {
            message.amount = string_1.StyledString.fromJSON(object.amount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.icon !== undefined) {
            obj.icon = icon_1.IconDescriptor.toJSON(message.icon);
        }
        if (message.title !== undefined) {
            obj.title = string_1.StyledString.toJSON(message.title);
        }
        if (message.subtitle !== undefined) {
            obj.subtitle = string_1.StyledString.toJSON(message.subtitle);
        }
        if (message.amount !== undefined) {
            obj.amount = string_1.StyledString.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.TableItem.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTableItem();
        message.icon = (object.icon !== undefined && object.icon !== null)
            ? icon_1.IconDescriptor.fromPartial(object.icon)
            : undefined;
        message.title = (object.title !== undefined && object.title !== null)
            ? string_1.StyledString.fromPartial(object.title)
            : undefined;
        message.subtitle = (object.subtitle !== undefined && object.subtitle !== null)
            ? string_1.StyledString.fromPartial(object.subtitle)
            : undefined;
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? string_1.StyledString.fromPartial(object.amount)
            : undefined;
        return message;
    },
};
function createBaseRelatedActivitySection() {
    return { relatedActivityIds: [] };
}
exports.RelatedActivitySection = {
    fromJSON(object) {
        const message = {
            relatedActivityIds: globalThis.Array.isArray(object?.relatedActivityIds)
                ? object.relatedActivityIds.map((e) => globalThis.String(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.relatedActivityIds?.length) {
            obj.relatedActivityIds = message.relatedActivityIds;
        }
        return obj;
    },
    create(base) {
        return exports.RelatedActivitySection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRelatedActivitySection();
        message.relatedActivityIds = object.relatedActivityIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseLocationSection() {
    return { name: '', location: undefined, address: undefined };
}
exports.LocationSection = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.name)) {
            message.name = globalThis.String(object.name);
        }
        if (isSet(object.location)) {
            message.location = geo_location_1.GeoLocation.fromJSON(object.location);
        }
        if (isSet(object.address)) {
            message.address = merchant_1.MerchantAddress.fromJSON(object.address);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== undefined && message.name !== '') {
            obj.name = message.name;
        }
        if (message.location !== undefined) {
            obj.location = geo_location_1.GeoLocation.toJSON(message.location);
        }
        if (message.address !== undefined) {
            obj.address = merchant_1.MerchantAddress.toJSON(message.address);
        }
        return obj;
    },
    create(base) {
        return exports.LocationSection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLocationSection();
        message.name = object.name ?? '';
        message.location = (object.location !== undefined && object.location !== null)
            ? geo_location_1.GeoLocation.fromPartial(object.location)
            : undefined;
        message.address = (object.address !== undefined && object.address !== null)
            ? merchant_1.MerchantAddress.fromPartial(object.address)
            : undefined;
        return message;
    },
};
function createBaseContactInfoSection() {
    return { phone: '' };
}
exports.ContactInfoSection = {
    fromJSON(object) {
        const message = {
            phone: isSet(object.phone) ? globalThis.String(object.phone) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.phone !== '') {
            obj.phone = message.phone;
        }
        return obj;
    },
    create(base) {
        return exports.ContactInfoSection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseContactInfoSection();
        message.phone = object.phone ?? '';
        return message;
    },
};
function createBaseActionsSection() {
    return { actions: [], purchase: exports.ActionablePurchase.fromPartial({}) };
}
exports.ActionsSection = {
    fromJSON(object) {
        const message = {
            actions: globalThis.Array.isArray(object?.actions)
                ? object.actions.map((e) => activity_action_1.ActivityAction.fromJSON(e))
                : [],
            purchase: isSet(object.purchase)
                ? exports.ActionablePurchase.fromJSON(object.purchase)
                : exports.ActionablePurchase.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.actions?.length) {
            obj.actions = message.actions.map((e) => activity_action_1.ActivityAction.toJSON(e));
        }
        if (message.purchase !== undefined) {
            obj.purchase = exports.ActionablePurchase.toJSON(message.purchase);
        }
        return obj;
    },
    create(base) {
        return exports.ActionsSection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActionsSection();
        message.actions = object.actions?.map((e) => activity_action_1.ActivityAction.fromPartial(e)) || [];
        message.purchase = (object.purchase !== undefined && object.purchase !== null)
            ? exports.ActionablePurchase.fromPartial(object.purchase)
            : exports.ActionablePurchase.fromPartial({});
        return message;
    },
};
function createBaseActionablePurchase() {
    return { purchaseAmount: amount_1.Amount.fromPartial({}), merchantName: '' };
}
exports.ActionablePurchase = {
    fromJSON(object) {
        const message = {
            purchaseAmount: isSet(object.purchaseAmount)
                ? amount_1.Amount.fromJSON(object.purchaseAmount)
                : amount_1.Amount.fromPartial({}),
            merchantName: isSet(object.merchantName) ? globalThis.String(object.merchantName) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.purchaseAmount !== undefined) {
            obj.purchaseAmount = amount_1.Amount.toJSON(message.purchaseAmount);
        }
        if (message.merchantName !== '') {
            obj.merchantName = message.merchantName;
        }
        return obj;
    },
    create(base) {
        return exports.ActionablePurchase.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActionablePurchase();
        message.purchaseAmount = (object.purchaseAmount !== undefined && object.purchaseAmount !== null)
            ? amount_1.Amount.fromPartial(object.purchaseAmount)
            : amount_1.Amount.fromPartial({});
        message.merchantName = object.merchantName ?? '';
        return message;
    },
};
function createBaseSupportSection() {
    return { disputable: undefined, cancelDispute: undefined };
}
exports.SupportSection = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.disputable)) {
            message.disputable = exports.SupportSectionDisputableActivity.fromJSON(object.disputable);
        }
        if (isSet(object.cancelDispute)) {
            message.cancelDispute = exports.SupportSectionCancelDispute.fromJSON(object.cancelDispute);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.disputable !== undefined) {
            obj.disputable = exports.SupportSectionDisputableActivity.toJSON(message.disputable);
        }
        if (message.cancelDispute !== undefined) {
            obj.cancelDispute = exports.SupportSectionCancelDispute.toJSON(message.cancelDispute);
        }
        return obj;
    },
    create(base) {
        return exports.SupportSection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSupportSection();
        message.disputable = (object.disputable !== undefined && object.disputable !== null)
            ? exports.SupportSectionDisputableActivity.fromPartial(object.disputable)
            : undefined;
        message.cancelDispute = (object.cancelDispute !== undefined && object.cancelDispute !== null)
            ? exports.SupportSectionCancelDispute.fromPartial(object.cancelDispute)
            : undefined;
        return message;
    },
};
function createBaseSupportSectionDisputableActivity() {
    return {
        merchantName: '',
        disputableTransactionId: '',
        isAtm: false,
        hasLoan: false,
        is3ds: false,
        cardId: '',
        isSecureAuth: false,
    };
}
exports.SupportSectionDisputableActivity = {
    fromJSON(object) {
        const message = {
            disputableTransactionId: isSet(object.disputableTransactionId)
                ? globalThis.String(object.disputableTransactionId)
                : '',
            isAtm: isSet(object.isAtm) ? globalThis.Boolean(object.isAtm) : false,
            hasLoan: isSet(object.hasLoan) ? globalThis.Boolean(object.hasLoan) : false,
            is3ds: isSet(object.is3ds) ? globalThis.Boolean(object.is3ds) : false,
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
            isSecureAuth: isSet(object.isSecureAuth) ? globalThis.Boolean(object.isSecureAuth) : false,
        };
        if (isSet(object.merchantName)) {
            message.merchantName = globalThis.String(object.merchantName);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchantName !== undefined && message.merchantName !== '') {
            obj.merchantName = message.merchantName;
        }
        if (message.disputableTransactionId !== '') {
            obj.disputableTransactionId = message.disputableTransactionId;
        }
        if (message.isAtm !== false) {
            obj.isAtm = message.isAtm;
        }
        if (message.hasLoan !== false) {
            obj.hasLoan = message.hasLoan;
        }
        if (message.is3ds !== false) {
            obj.is3ds = message.is3ds;
        }
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.isSecureAuth !== false) {
            obj.isSecureAuth = message.isSecureAuth;
        }
        return obj;
    },
    create(base) {
        return exports.SupportSectionDisputableActivity.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSupportSectionDisputableActivity();
        message.merchantName = object.merchantName ?? '';
        message.disputableTransactionId = object.disputableTransactionId ?? '';
        message.isAtm = object.isAtm ?? false;
        message.hasLoan = object.hasLoan ?? false;
        message.is3ds = object.is3ds ?? false;
        message.cardId = object.cardId ?? '';
        message.isSecureAuth = object.isSecureAuth ?? false;
        return message;
    },
};
function createBaseSupportSectionCancelDispute() {
    return { disputedTransactionId: '' };
}
exports.SupportSectionCancelDispute = {
    fromJSON(object) {
        const message = {
            disputedTransactionId: isSet(object.disputedTransactionId)
                ? globalThis.String(object.disputedTransactionId)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.disputedTransactionId !== '') {
            obj.disputedTransactionId = message.disputedTransactionId;
        }
        return obj;
    },
    create(base) {
        return exports.SupportSectionCancelDispute.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSupportSectionCancelDispute();
        message.disputedTransactionId = object.disputedTransactionId ?? '';
        return message;
    },
};
function createBaseParagraphsSection() {
    return { paragraphs: [] };
}
exports.ParagraphsSection = {
    fromJSON(object) {
        const message = {
            paragraphs: globalThis.Array.isArray(object?.paragraphs)
                ? object.paragraphs.map((e) => string_1.StyledString.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paragraphs?.length) {
            obj.paragraphs = message.paragraphs.map((e) => string_1.StyledString.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ParagraphsSection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseParagraphsSection();
        message.paragraphs = object.paragraphs?.map((e) => string_1.StyledString.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCashAdvanceCompletedBnplPlansSection() {
    return { loans: [] };
}
exports.CashAdvanceCompletedBnplPlansSection = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.loans)) {
            message.loans = object.loans.map((e) => activity_common_1.CompletedLoan.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.loans?.length) {
            obj.loans = message.loans.map((e) => activity_common_1.CompletedLoan.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.CashAdvanceCompletedBnplPlansSection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCashAdvanceCompletedBnplPlansSection();
        message.loans = object.loans?.map((e) => activity_common_1.CompletedLoan.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCheckImageSection() {
    return { frontImageId: '', backImageId: '' };
}
exports.CheckImageSection = {
    fromJSON(object) {
        const message = {
            frontImageId: isSet(object.frontImageId) ? globalThis.String(object.frontImageId) : '',
            backImageId: isSet(object.backImageId) ? globalThis.String(object.backImageId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.frontImageId !== '') {
            obj.frontImageId = message.frontImageId;
        }
        if (message.backImageId !== '') {
            obj.backImageId = message.backImageId;
        }
        return obj;
    },
    create(base) {
        return exports.CheckImageSection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCheckImageSection();
        message.frontImageId = object.frontImageId ?? '';
        message.backImageId = object.backImageId ?? '';
        return message;
    },
};
function createBaseRelatedGiftCardSection() {
    return {
        orderId: '',
        orderCreatedAtMs: '0',
        productName: '',
        cardImageUrl: '',
        cardValue: amount_1.Amount.fromPartial({}),
    };
}
exports.RelatedGiftCardSection = {
    fromJSON(object) {
        const message = {
            orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : '',
            orderCreatedAtMs: isSet(object.orderCreatedAtMs)
                ? globalThis.String(object.orderCreatedAtMs)
                : '0',
            productName: isSet(object.productName) ? globalThis.String(object.productName) : '',
            cardImageUrl: isSet(object.cardImageUrl) ? globalThis.String(object.cardImageUrl) : '',
            cardValue: isSet(object.cardValue)
                ? amount_1.Amount.fromJSON(object.cardValue)
                : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.orderId !== '') {
            obj.orderId = message.orderId;
        }
        if (message.orderCreatedAtMs !== '0') {
            obj.orderCreatedAtMs = message.orderCreatedAtMs;
        }
        if (message.productName !== '') {
            obj.productName = message.productName;
        }
        if (message.cardImageUrl !== '') {
            obj.cardImageUrl = message.cardImageUrl;
        }
        if (message.cardValue !== undefined) {
            obj.cardValue = amount_1.Amount.toJSON(message.cardValue);
        }
        return obj;
    },
    create(base) {
        return exports.RelatedGiftCardSection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRelatedGiftCardSection();
        message.orderId = object.orderId ?? '';
        message.orderCreatedAtMs = object.orderCreatedAtMs ?? '0';
        message.productName = object.productName ?? '';
        message.cardImageUrl = object.cardImageUrl ?? '';
        message.cardValue = (object.cardValue !== undefined && object.cardValue !== null)
            ? amount_1.Amount.fromPartial(object.cardValue)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseCardReplacementSection() {
    return { cardId: '' };
}
exports.CardReplacementSection = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        return obj;
    },
    create(base) {
        return exports.CardReplacementSection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardReplacementSection();
        message.cardId = object.cardId ?? '';
        return message;
    },
};
function createBaseMerchantActivitySection() {
    return { merchantId: '' };
}
exports.MerchantActivitySection = {
    fromJSON(object) {
        const message = {
            merchantId: isSet(object.merchantId) ? globalThis.String(object.merchantId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchantId !== '') {
            obj.merchantId = message.merchantId;
        }
        return obj;
    },
    create(base) {
        return exports.MerchantActivitySection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMerchantActivitySection();
        message.merchantId = object.merchantId ?? '';
        return message;
    },
};
function createBaseRetrySavingsMatchingSection() {
    return { destinationUserId: '', destinationUserFirstName: '', savingsGoalTitle: '' };
}
exports.RetrySavingsMatchingSection = {
    fromJSON(object) {
        const message = {
            destinationUserId: isSet(object.destinationUserId)
                ? globalThis.String(object.destinationUserId)
                : '',
        };
        if (isSet(object.destinationUserFirstName)) {
            message.destinationUserFirstName = globalThis.String(object.destinationUserFirstName);
        }
        if (isSet(object.savingsGoalTitle)) {
            message.savingsGoalTitle = globalThis.String(object.savingsGoalTitle);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.destinationUserId !== '') {
            obj.destinationUserId = message.destinationUserId;
        }
        if (message.destinationUserFirstName !== undefined && message.destinationUserFirstName !== '') {
            obj.destinationUserFirstName = message.destinationUserFirstName;
        }
        if (message.savingsGoalTitle !== undefined && message.savingsGoalTitle !== '') {
            obj.savingsGoalTitle = message.savingsGoalTitle;
        }
        return obj;
    },
    create(base) {
        return exports.RetrySavingsMatchingSection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRetrySavingsMatchingSection();
        message.destinationUserId = object.destinationUserId ?? '';
        message.destinationUserFirstName = object.destinationUserFirstName ?? '';
        message.savingsGoalTitle = object.savingsGoalTitle ?? '';
        return message;
    },
};
function createBaseBnplRepaymentSection() {
    return { loanAccountId: '' };
}
exports.BnplRepaymentSection = {
    fromJSON(object) {
        const message = {
            loanAccountId: isSet(object.loanAccountId) ? globalThis.String(object.loanAccountId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.loanAccountId !== '') {
            obj.loanAccountId = message.loanAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.BnplRepaymentSection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBnplRepaymentSection();
        message.loanAccountId = object.loanAccountId ?? '';
        return message;
    },
};
function createBaseFeeBreakdownSection() {
    return {
        transaction: exports.FeeBreakdownSectionFeeBreakdownRow.fromPartial({}),
        fee: exports.FeeBreakdownSectionFeeBreakdownRow.fromPartial({}),
        additionalFee: undefined,
        total: exports.FeeBreakdownSectionFeeBreakdownRow.fromPartial({}),
    };
}
exports.FeeBreakdownSection = {
    fromJSON(object) {
        const message = {
            transaction: isSet(object.transaction)
                ? exports.FeeBreakdownSectionFeeBreakdownRow.fromJSON(object.transaction)
                : exports.FeeBreakdownSectionFeeBreakdownRow.fromPartial({}),
            fee: isSet(object.fee)
                ? exports.FeeBreakdownSectionFeeBreakdownRow.fromJSON(object.fee)
                : exports.FeeBreakdownSectionFeeBreakdownRow.fromPartial({}),
            total: isSet(object.total)
                ? exports.FeeBreakdownSectionFeeBreakdownRow.fromJSON(object.total)
                : exports.FeeBreakdownSectionFeeBreakdownRow.fromPartial({}),
        };
        if (isSet(object.additionalFee)) {
            message.additionalFee = exports.FeeBreakdownSectionFeeBreakdownRow.fromJSON(object.additionalFee);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transaction !== undefined) {
            obj.transaction = exports.FeeBreakdownSectionFeeBreakdownRow.toJSON(message.transaction);
        }
        if (message.fee !== undefined) {
            obj.fee = exports.FeeBreakdownSectionFeeBreakdownRow.toJSON(message.fee);
        }
        if (message.additionalFee !== undefined) {
            obj.additionalFee = exports.FeeBreakdownSectionFeeBreakdownRow.toJSON(message.additionalFee);
        }
        if (message.total !== undefined) {
            obj.total = exports.FeeBreakdownSectionFeeBreakdownRow.toJSON(message.total);
        }
        return obj;
    },
    create(base) {
        return exports.FeeBreakdownSection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFeeBreakdownSection();
        message.transaction = (object.transaction !== undefined && object.transaction !== null)
            ? exports.FeeBreakdownSectionFeeBreakdownRow.fromPartial(object.transaction)
            : exports.FeeBreakdownSectionFeeBreakdownRow.fromPartial({});
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? exports.FeeBreakdownSectionFeeBreakdownRow.fromPartial(object.fee)
            : exports.FeeBreakdownSectionFeeBreakdownRow.fromPartial({});
        message.additionalFee = (object.additionalFee !== undefined && object.additionalFee !== null)
            ? exports.FeeBreakdownSectionFeeBreakdownRow.fromPartial(object.additionalFee)
            : undefined;
        message.total = (object.total !== undefined && object.total !== null)
            ? exports.FeeBreakdownSectionFeeBreakdownRow.fromPartial(object.total)
            : exports.FeeBreakdownSectionFeeBreakdownRow.fromPartial({});
        return message;
    },
};
function createBaseFeeBreakdownSectionFeeBreakdownRow() {
    return { title: '', amount: amount_1.Amount.fromPartial({}) };
}
exports.FeeBreakdownSectionFeeBreakdownRow = {
    fromJSON(object) {
        const message = {
            title: isSet(object.title) ? globalThis.String(object.title) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.title !== '') {
            obj.title = message.title;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.FeeBreakdownSectionFeeBreakdownRow.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFeeBreakdownSectionFeeBreakdownRow();
        message.title = object.title ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseTimelineSection() {
    return { events: [] };
}
exports.TimelineSection = {
    fromJSON(object) {
        const message = {
            events: globalThis.Array.isArray(object?.events)
                ? object.events.map((e) => exports.TimelineSectionTimelineEvent.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.events?.length) {
            obj.events = message.events.map((e) => exports.TimelineSectionTimelineEvent.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.TimelineSection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTimelineSection();
        message.events = object.events?.map((e) => exports.TimelineSectionTimelineEvent.fromPartial(e)) || [];
        return message;
    },
};
function createBaseTimelineSectionTimelineEvent() {
    return { event: string_1.StyledString.fromPartial({}), description: string_1.StyledString.fromPartial({}) };
}
exports.TimelineSectionTimelineEvent = {
    fromJSON(object) {
        const message = {
            event: isSet(object.event)
                ? string_1.StyledString.fromJSON(object.event)
                : string_1.StyledString.fromPartial({}),
            description: isSet(object.description)
                ? string_1.StyledString.fromJSON(object.description)
                : string_1.StyledString.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.event !== undefined) {
            obj.event = string_1.StyledString.toJSON(message.event);
        }
        if (message.description !== undefined) {
            obj.description = string_1.StyledString.toJSON(message.description);
        }
        return obj;
    },
    create(base) {
        return exports.TimelineSectionTimelineEvent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTimelineSectionTimelineEvent();
        message.event = (object.event !== undefined && object.event !== null)
            ? string_1.StyledString.fromPartial(object.event)
            : string_1.StyledString.fromPartial({});
        message.description = (object.description !== undefined && object.description !== null)
            ? string_1.StyledString.fromPartial(object.description)
            : string_1.StyledString.fromPartial({});
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=activity-details-section.js.map